import { Link, useLocation } from "react-router-dom"
import useAuth from "../hook/useAuth";

export const TopBar = () => {
    const { auth }: any = useAuth();
    const location = useLocation();

    return (
        <div className="w-full bg-primary text-white text-sm">
            <div className="px-8 py-1 w-full flex items-center justify-between">

                <div className="flex items-center gap-2 px-4 py-2 border-r border-l">
                    <span className="material-symbols-outlined text-xl">
                        call
                    </span>
                    <span className="text-xs font-semibold">(844) 438-0647</span>
                </div>


                <div className="flex">
                    {
                        (auth?.roles !== "Admin" && !location.pathname.includes("admin")) && (
                            <div className="flex items-center gap-2 px-4 py-2 border-l">
                                <span className="material-symbols-outlined text-xl">
                                    person
                                </span>
                                <p>
                                    <Link to="/login" className="text-xs font-semibold hover:underline">
                                        Login
                                    </Link>
                                </p>
                            </div>
                        )
                    }

                    {
                        (auth?.roles === "Admin") && (
                            <div className="flex items-center gap-2 px-4 py-2 border-l">
                                <span className="material-symbols-outlined text-xl">
                                    dashboard
                                </span>
                                <p>
                                    <Link to="/admin/dashboard" className="text-xs font-semibold hover:underline">
                                        Dashboard
                                    </Link>
                                </p>
                            </div>
                        )
                    }

                    <div className="flex items-center gap-2 px-4 py-2 border-l border-r">
                        <span className="material-symbols-outlined text-xl">
                            shopping_cart
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}